import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchItem(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/user/user-get`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        editItem(ctx, dataInfo) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/user/user-save', dataInfo)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        changePassword(ctx, dataInfo) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/user/change-password', dataInfo)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
